import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import CallMadeIcon from '@material-ui/icons/CallMade';
import RoomIcon from '@material-ui/icons/Room';

import { InfoTooltip } from 'lib';
import { formatCoordinates, googleMapsUrl } from 'helpers/formatCoordinates';
import styles from '../../styles';

const ImageLocation = ({ classes, coordinates }) => (
  <InfoTooltip
    content={
      <div className={classes.locationContent}>
        <span className={classes.locationLabel}>Coordinates:</span>
        <span className={classes.locationValue}>
          {formatCoordinates(coordinates)}
          <IconButton
            size="small"
            className={classes.mapsLink}
            aria-label="Open in Google Maps"
            href={googleMapsUrl(coordinates)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <CallMadeIcon fontSize="inherit" />
          </IconButton>
        </span>
      </div>
    }
    placement="top"
    surface="light"
    size="default"
    interactive
    icon={<RoomIcon className={classes.pin} fontSize="small" />}
  />
);

export default withStyles(styles)(ImageLocation);
